import { AppThemeConfiguration } from '/@/shared/themes/app-theme-types';

export const defaultDark: AppThemeConfiguration = {
    app: {},
    colors: {
        primary: 'rgb(53, 116, 252)',
    },
    mode: 'dark',
};
